import { NavLink } from "react-router-dom";
import logo from "../assets/logo-modified.svg";
import '../assets/styles/app.css';
import { useDispatch } from "react-redux";
import { deleteLoginUser } from '../common_functions/store';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder, faTags, faServer, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { CollectionIcon, NeuralNetworkSvg, MenuCollectionIcon, LogOutIcon, SettingsIcon, SubscriptionIcon, ProfileIcon } from "../icon_templates/icons";
import FolderZipIcon from '@mui/icons-material/FolderZip';
import { CgProfile } from "react-icons/cg";
import { useEffect, useState } from "react";


export const AppNavBar = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const authToken = useSelector(state => state.authtoken);
  const username = localStorage.getItem('username');
  const role = localStorage.getItem('role');

  const logOutUser = () => {
    dispatch(deleteLoginUser());
    localStorage.removeItem('authToken');
    localStorage.removeItem('role');
    localStorage.removeItem('email');
    navigate("/login");
  }

  return (
    <nav
      className='navbarcontainer navbar navbar-expand-lg bg-body-tertiary rounded-0 p-1 border border-top-0 border-end-0 border-start-0 border-bottom-0 shadow-sm'
      aria-label='Thirteenth navbar example'
    >
      <div className='container-fluid'>
        <button
          className='navbar-toggler'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#navbarsExample11'
          aria-controls='navbarsExample11'
          aria-expanded='false'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon'></span>
        </button>

        <div
          className='collapse navbar-collapse d-lg-flex'
          id='navbarsExample11'
        >
          <a className='navbar-brand col-lg-3 me-0' href='#'>
            <img
              src={logo}
              alt='logo'
              width='160'
              className='d-inline-block align-text-top'
            />
          </a>
          <ul className='navbar-nav col-lg-6 justify-content-lg-center'>
            <div className='nav-item'>
              <NavLink to='/explorer' className='nav-link'>
                <FontAwesomeIcon
                  icon={faFolder}
                  className='menu-icons explorer-icon'
                />
                Explorer
              </NavLink>
            </div>
            <div className='nav-item'>
              <NavLink to='/collections' className='nav-link'>
                <MenuCollectionIcon className='menu-icons' />
                Collections
              </NavLink>
            </div>
            <div className='nav-item'>
              <NavLink to='/tags' className='nav-link'>
                <FontAwesomeIcon
                  icon={faTags}
                  className='menu-icons tags-menu-icon'
                />
                Tags
              </NavLink>
            </div>
            <div className='nav-item'>
              <NavLink to='/models' className='nav-link'>
                <NeuralNetworkSvg className='menu-icons explorer-icon' />
                Models
              </NavLink>
            </div>
            <div className='nav-item'>
              <NavLink to='/agents' className='nav-link'>
                <FontAwesomeIcon
                  icon={faServer}
                  className='menu-icons-agents'
                />
                Agents
              </NavLink>
            </div>
            <div className='nav-item'>
              <NavLink to='/datasets' className='nav-link'>
                <FolderZipIcon className='menu-agents-icon' />
                Datasets
              </NavLink>
            </div>
          </ul>
          <div className='profile-controll-container'>
            <div className='container align-right'>
              <div className='row'>
                <div className='col-lg-12 col-md-12 col-12'>
                  <ul className='list-unstyled'>
                    <li className='dropdown ml-2'>
                      <a
                        className='rounded-circle '
                        href='#'
                        role='button'
                        id='dropdownUser'
                        data-toggle='dropdown'
                        aria-haspopup='true'
                        aria-expanded='false'
                      >
                        <div className='avatar avatar-md avatar-indicators avatar-online'>
                          <CgProfile className='profile-img' />
                        </div>
                      </a>

                      <div
                        className='dropdown-menu dropdown-menu-right pb-2'
                        aria-labelledby='dropdownUser'
                      >
                        <div className='dropdown-item'>
                          <div className='d-flex py-2'>
                            <div className='avatar avatar-md avatar-indicators avatar-online'>
                              <CgProfile className='profile-img' />
                            </div>
                            <div className='ml-6 lh-1 user-menu-dropdown'>
                              <h5 className='mb-0'>{username}</h5>
                              <p className='mb-0'>{role}</p>
                            </div>
                          </div>
                        </div>
                        <div className='dropdown-divider'></div>
                        <div className=''>
                          <ul className='list-unstyled'>
                            {/* <li className="dropdown-submenu dropright-lg">
                              <a className="dropdown-item dropdown-item-cursom dropdown-list-group-item dropdown-toggle" href="#">
                                <span className="mr-1">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-circle"><circle cx="12" cy="12" r="10" ></circle></svg></span><span> Status
                              </span></a>
                              <ul className="dropdown-menu">
                                <li>
                                  <a className="dropdown-item text-success" href="#!">
                                    Online
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item text-black-50" href="#!">
                                    Offline
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item text-info" href="#!">
                                    Away
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item text-danger" href="#!">
                                    Busy
                                  </a>
                                </li>
                              </ul>
                            </li> */}
                            {/* <li>
                              <a className='dropdown-item dropdown-item-cursom' href="/profile">
                                <span className='mr-1'>
                                  <ProfileIcon />
                                </span>
                                Profile
                              </a>
                            </li> */}
                            {/* <li>
                              <div className='dropdown-item dropdown-item-cursom'>
                                <span className='mr-2'>
                                  <SubscriptionIcon />
                                </span>
                                Subscription
                              </div>
                            </li> */}
                            <li>
                              <a className='dropdown-item dropdown-item-cursom' href="/admin">
                                <span className='mr-2'>
                                  <SettingsIcon />
                                </span>
                                Dashboard
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className='dropdown-divider'></div>
                        <ul className='list-unstyled'>
                          <li onClick={logOutUser}>
                            <div className='dropdown-item dropdown-item-cursom'>
                              <span className='mr-2'>
                                <LogOutIcon />
                              </span>
                              Log Out
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};
